<template>
  <div class="sidebar" :class="setFamily()">
    <div
      class="menu"
      :class="{ menu2: i == 1 }"
      v-for="(menu, i) in menus"
      :key="menu.value"
    >
      <div class="menu-label" :class="{ cp: !menu.children }"  @click="handleChange(menu)">
          {{ $t(menu.label) }}
        <div class="line" v-if="menu.children"></div>
      </div>
      <Sidebar-menu
        :class="{ menu2: i == 1 }"
        v-if="menu.children"
        :data="menu.children"
        :component="component"
        :parent="parent"
        @change="handleChange"
      />
    </div>
  </div>
</template>

<script>
import SidebarMenu from './sidebar-menu.vue'
export default {
  name: 'Sidebar',
  components: { SidebarMenu },
  props: ['menus', 'component', 'parent'],
  data() {
    return {
      isZh: true,
    }
  },
  methods: {
    handleChange(val) {
      this.$emit('change', val)
    },
    setFamily() {
      let lang = localStorage.getItem('translate')
      return lang
    }
  },
}
</script>

<style lang="scss" scoped>
.sidebar {
  $sw: calc(100% + 1em);
  width: fit-content;
  display: flex;
  flex-direction: column;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  .menu {
    color: var(--red-color);
    display: flex;
    align-items: center;
    margin-bottom: 2em;
    &:last-child {
      margin-bottom: 0;
    }
    &-label {
      position: relative;
      width: 6em;
      height: fit-content;
      background-color: rgba($color: #fff5f5, $alpha: 0.9);
      padding: 0.5em;
      transform: translateY(-10%);
      .line {
        position: absolute;
        top: calc(100% + 5px);
        left: 0;
        width: calc(100% + 1em);
        height: 2px;
        background: #fff;
      }
    }
  }
}
.menu2 {
  color: var(--exp-color) !important;
  :deep {
    .cp:hover {
      background-color: var(--exp-color) !important;
    }
  }
}
.en {
  font-size: 16px;
  .menu-label {
    width: 7em;
  }
}
</style>